import styled from "styled-components";

export const CompanyPickerStyled = styled.div`
  height: 100%;
  display: flex;
  box-sizing: border-box;
  align-items: center;
  margin-right: 24px;
  position: relative;
`;

export const CompanyLabelStyled = styled.div`
  max-width: 240px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: rgba(255, 255, 255, 0.7);
`;

interface ActiveProps {
  $active: boolean;
}

export const CompanyToggleStyled = styled.div<ActiveProps>`
  max-width: 240px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  cursor: pointer;
  transition: color 0.3s;
  color: ${(props) => (props.$active ? "#55b8b3" : "#ffffff")};

  &:hover {
    color: #55b8b3;
  }
`;

export const CompanyListStyled = styled.div`
  display: flex;
  flex-direction: column;
  position: absolute;
  background-color: #ffffff;
  min-width: 200px;
  right: 0;
  top: 71px;
  box-sizing: border-box;
  padding: 8px 0;
  z-index: 2;
  box-shadow: rgba(149, 157, 165, 0.2) 0 8px 24px;
`;

export const CompanyListItemStyled = styled.a<ActiveProps>`
  display: flex;
  align-items: center;
  width: 100%;
  height: 44px;
  cursor: pointer;
  font-weight: 400;
  font-size: 16px;
  line-height: 128%;
  color: ${(props) => (props.$active ? "#55b8b3" : "#606060")};
  text-decoration: none;
  box-sizing: border-box;
  padding: 0 18px;
  border-bottom: 1px solid transparent;
  transition: all 0.3s;

  &:hover {
    color: #55b8b3;
    border-bottom: 1px solid #55b8b3;
  }
`;
